<template>
  <div class="drop-down-box-item">
    <div class="label-title">{{ data.title }}</div>
    <div class="down-list-wrap">
      <div class="input-wrap" ref="inputWrap" @click="openDownList">
        <input type="text" placeholder="请选择" v-if="isSearch" />
        <div class="selected-label" v-else>{{ curLabel }}</div>
        <img src="../../assets/arrow.png" alt="" />
      </div>
      <div class="list" v-show="isList">
        <div
          class="item"
          v-for="(item, index) in data.list"
          :key="index"
          @click="choose(item, index)"
        >
          <img v-if="item.icon_url" :src="item.icon_url" alt="" />
          <span :class="{ small: item.icon_url }">{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
    platform: {
      type: Number,
    },
  },
  data() {
    return {
      isSearch: false,
      isList: false,
      curLabel: '',
      curLabelIndex: 0,
    };
  },

  computed: {},

  watch: {
    platform: {
      handler(n, o) {
        if (!this.data.system) {
          this.curLabelIndex = 0;
        } else {
          let index = 0;
          if (this.platform === 0) {
            index = 1;
          }
          this.curLabelIndex = index;
          this.curLabel = this.data.list[index].label;
        }
      },
      immediate: true,
    },
    data(data) {
      if (data.list[this.curLabelIndex]) {
        this.curLabel = data.list[this.curLabelIndex].label;
      } else {
        this.curLabel = data.list[0].label;
      }
    },
  },
  mounted() {
    // 监听，除了点击自己，点击其他地方将自身隐藏
    document.addEventListener('click', this.onOutside);
  },
  methods: {
    choose(item, index) {
      // console.log('item', item)
      this.curLabel = item.label;
      this.curLabelIndex = index;
      if (this.data.system) {
        this.$emit('getPlatform', item.platform);
      }
      if (this.data.version) {
        this.$emit('getVersion', item.version);
      }
      if (this.data.channel) {
        this.$emit('getChannel', item.channel);
      }
    },
    openDownList() {
      this.isList = true;
    },
    onOutside(e) {
      const inputWrap = this.$refs.inputWrap;
      if (inputWrap && !inputWrap.contains(e.target)) {
        this.isList = false;
        // const contentWrap = document.querySelector('.lang-box')
        // if (contentWrap) {
        //   if (!contentWrap.contains(e.target)) {

        //   }
        // }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.drop-down-box-item {
  display: flex;
  align-items: center;
  .label-title {
    font-size: 14px;
    color: #9ea0a5;
  }
  .down-list-wrap {
    margin-left: 12px;
    position: relative;
    width: 212px;
    height: 48px;
    background: #ffffff;
    border: 1px solid #e6e8ea;
    border-radius: 10px;
    box-shadow: 0px 80.67px 67.05px 0px rgba(0, 0, 0, 0.02);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    .input-wrap {
      width: 100%;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      input {
        border: none;
        outline: none;
      }
      .selected-label {
        font-size: 14px;
        font-weight: 500;
        color: #000000;
      }
      img {
        width: 20px;
        height: 20px;
      }
    }
    .list {
      position: absolute;
      z-index: 10;
      top: 54px;
      left: 0;
      width: 212px;
      max-height: 296px;
      padding: 8px 0;
      overflow: auto;
      background: #ffffff;
      border: 1px solid #f1f3f5;
      border-radius: 12px;
      box-shadow: 0px 6px 16px 0px rgba(45, 54, 86, 0.05);
      overflow: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }
      .item {
        display: flex;
        align-items: center;
        padding: 16px 20px;
        cursor: pointer;
        img {
          width: 24px;
          height: 24px;
          border-radius: 4px;
        }
        span {
          font-size: 16px;
          font-weight: 500;
          color: #3a3b3d;
          &.small {
            margin-left: 8px;
            font-size: 14px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .drop-down-box-item {
    .label-title {
      white-space: nowrap;
      font-size: 13px;
    }
    .down-list-wrap {
      width: 100%;
      height: 40px;
      padding: 0 8px;
      .input-wrap {
        .selected-label {
          font-size: 13px;
        }
      }
      .list {
        top: 44px;
        width: inherit;
        .item {
          padding: 12px 20px;
          span {
            font-size: 13px;
            font-weight: 500;
            color: #000;
          }
        }
      }
    }
  }
}
</style>
